/**
 * Initializes Splide carousels for information block points on mobile
 */
(function () {
  'use strict';

  function initCustomContentLayoutCarousels(sectionId) {
    var SplideConstructor = null;
    var splideScriptLoaded = false;
    var splideCSSLoaded = false;
    var carouselSelector = '#shopify-section-' + sectionId + ' .custom-content-layout__information-points-mobile.splide';

    function loadSplideCSS() {
      if (splideCSSLoaded || document.querySelector('link[href*="splide"]')) {
        splideCSSLoaded = true;
        return;
      }

      /*
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css';
      link.onload = function () {
        splideCSSLoaded = true;
      };
      document.head.appendChild(link);
      */
    }

    function loadSplideFromCDN(callback) {
      if (splideScriptLoaded) {
        callback();
        return;
      }

      loadSplideCSS();

      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
      script.onload = function () {
        splideScriptLoaded = true;
        callback();
      };
      script.onerror = callback;
      document.head.appendChild(script);
    }

    function findSplideConstructor() {
      if (typeof window.Splide === 'function') {
        return window.Splide;
      }
      return null;
    }

    function initCarousels() {
      if (window.innerWidth >= 1024) {
        return;
      }

      if (!SplideConstructor) {
        SplideConstructor = findSplideConstructor();
      }

      if (!SplideConstructor && !splideScriptLoaded) {
        loadSplideFromCDN(function () {
          SplideConstructor = findSplideConstructor();
          if (SplideConstructor) {
            initCarousels();
          }
        });
        return;
      }

      if (!SplideConstructor) {
        return;
      }

      var carousels = document.querySelectorAll(carouselSelector);

      carousels.forEach(function (carousel) {
        if (carousel.splideInstance) {
          return;
        }

        var slideCount = carousel.querySelectorAll('.splide__slide').length;
        if (slideCount === 0) {
          return;
        }

        try {
          var splideInstance = new SplideConstructor(carousel, {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            pagination: slideCount > 1,
            arrows: false,
            width: '100%',
            gap: 0,
            classes: {
              pagination: 'splide__pagination',
            },
          });

          splideInstance.mount();
          carousel.splideInstance = splideInstance;
        } catch (error) {
          // Silently fail
        }
      });
    }

    function destroyCarousels() {
      var carousels = document.querySelectorAll(carouselSelector);
      carousels.forEach(function (carousel) {
        if (carousel.splideInstance) {
          try {
            carousel.splideInstance.destroy();
            carousel.splideInstance = null;
          } catch (error) {
            // Silently fail
          }
        }
      });
    }

    // Initialize
    if (document.readyState === 'loading') {
      window.addEventListener('load', initCarousels);
    } else {
      setTimeout(initCarousels, 100);
    }

    // Handle Shopify theme editor
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        if (event.detail.sectionId === sectionId) {
          SplideConstructor = null;
          setTimeout(initCarousels, 100);
        }
      });

      document.addEventListener('shopify:section:unload', function (event) {
        if (event.detail.sectionId === sectionId) {
          destroyCarousels();
        }
      });
    }

    // Handle resize
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (window.innerWidth >= 1024) {
          destroyCarousels();
        } else {
          SplideConstructor = null;
          initCarousels();
        }
      }, 250);
    });
  }

  window.initCustomContentLayoutCarousels = initCustomContentLayoutCarousels;
})();
